import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const SchoolsRepository = RepositoryFactory.get("schools");

const state = {
  schools: [],
  school: {},
  allSelected: false,
};

const getters = {
  getSchools: () => state.schools,
  getSchool: () => state.school,
};

const actions = {
  purgeSelectedSchools({ commit, dispatch, state }, deleteSchools = false) {
    let schoolsToPurge = [];
    if (!state.allSelected) {
      schoolsToPurge = state.schools.filter((s) => s.selected).map((s) => s.id);
    }

    const payload = {
      all_selected: state.allSelected,
      delete_schools: deleteSchools,
      schools_to_purge_ids: schoolsToPurge,
    };

    return SchoolsRepository.purgeSchools(payload)
      .then(() => {
        if (deleteSchools) {
          schoolsToPurge.forEach((sid) => {
            let i = state.schools.findIndex((s) => s.id === sid);
            if (i != -1) {
              commit("REMOVE_SCHOOL", i);
            }
          });
        }

        commit("SET_ALL_SELECTED", false);
        commit("SELECT_ALL");

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(`message.notifications.schools.purgeSuccess`),
          },
          { root: true },
        );
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.schools.purgeError`),
          },
          { root: true },
        );
      });
  },
  purgeCurrentSchool({ commit, dispatch, state }, deleteSchool = false) {
    const payload = {
      all_selected: false,
      delete_schools: deleteSchool,
      schools_to_purge_ids: [state.school.id],
    };

    return SchoolsRepository.purgeSchools(payload)
      .then(() => {
        if (deleteSchool) {
          let i = state.schools.findIndex((s) => s.id === state.school.id);
          if (i != -1) {
            commit("REMOVE_SCHOOL", i);
          }
        }

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(`message.notifications.schools.purgeSuccess`),
          },
          { root: true },
        );
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.schools.purgeError`),
          },
          { root: true },
        );
      });
  },
  selectAll({ commit }, allSelected) {
    commit("SET_ALL_SELECTED", allSelected);
    commit("SELECT_ALL");
  },
  getSchools({ commit, dispatch, state }, params = {}) {
    SchoolsRepository.getSchools(params)
      .then((response) => {
        let schools = [];
        if (params.version == 1) {
          schools = response.data.results;
          const totalPages = response.data.total_pages;
          commit("pagination/SET_TOTAL_PAGES", totalPages, { root: true });
        } else {
          schools = response.data;
        }
        commit("SAVE_SCHOOLS", schools);
        commit("SELECT_ALL");
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.schools.getSchoolsError`),
          },
          { root: true },
        );
      });
  },
  getSchool({ commit, dispatch, state }, id) {
    SchoolsRepository.getSchool(id)
      .then((response) => {
        const school = response.data;
        commit("SAVE_SCHOOL", school);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.schools.getSchoolError`),
          },
          { root: true },
        );
      });
  },
  updateSchool({ commit, dispatch }, payload) {
    SchoolsRepository.updateSchool(payload)
      .then((response) => {
        const school = response.data;
        commit("SAVE_SCHOOL", school);
        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.schools.updateSchoolSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.schools.updateSchoolError`,
            ),
          },
          { root: true },
        );
      });
  },
  createSchool({ commit, dispatch, state }, payload) {
    SchoolsRepository.createSchool(payload)
      .then((response) => {
        const school = response.data;
        commit("SAVE_SCHOOL", school);

        if (state.schools.length > 0) {
          commit("ADD_SCHOOL", school);
        }

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.schools.createSchoolSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch((error) => {
        if (error.response.status === 409) {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(
                `message.notifications.schools.createSchoolAlreadyExistError`,
              ),
            },
            { root: true },
          );
        } else {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(
                `message.notifications.schools.createSchoolError`,
              ),
            },
            { root: true },
          );
        }
      });
  },
  getSchoolClasses({ dispatch, state }, id) {
    return SchoolsRepository.retrieveSchoolClasses(id)
      .then((response) => {
        return response;
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.schools.getSchoolsError`),
          },
          { root: true },
        );
      });
  },
  resetSchools({ commit }) {
    commit("RESET_SCHOOLS");
  },
};

const mutations = {
  SAVE_SCHOOLS(state, schools) {
    state.schools = schools;
  },
  ADD_SCHOOL(state, school) {
    state.schools.push(school);
  },
  SAVE_SCHOOL(state, school) {
    state.school = school;
  },
  RESET_SCHOOLS(state) {
    state.schools = [];
  },
  SET_ALL_SELECTED(state, allSelected) {
    state.allSelected = allSelected;
  },
  SELECT_ALL(state) {
    state.schools.forEach((school) => (school.selected = state.allSelected));
  },
  REMOVE_SCHOOL(state, schoolIndex) {
    state.schools.splice(schoolIndex, 1);
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
